import { FC, useMemo } from 'react';

import ExternalLink from '@/components/ExternalLink.tsx';

import useConfig from '@/hooks/useConfig.ts';

import { buildPatientFolderUrl } from '@/utils/instanceUtils.ts';

interface Props {
    pvsPatientId: string;
    instanceId: string;
}

const PatientRecordLink: FC<Props> = ({ pvsPatientId, instanceId }) => {
    const { getInstanceConfig } = useConfig();

    const patient_folder_deep_link: string | undefined = useMemo(() => {
        if (!instanceId || !pvsPatientId) {
            return '';
        }

        const config = getInstanceConfig(instanceId);
        if (!config?.domain || !config?.pvs_provider) {
            return '';
        }

        return buildPatientFolderUrl(config.pvs_provider, config.domain, pvsPatientId);
    }, [pvsPatientId, instanceId, getInstanceConfig]);

    if (!patient_folder_deep_link) {
        return undefined;
    }

    return <ExternalLink text="Patientenakte" href={patient_folder_deep_link} classNames={{ anchor: 'text-black' }} />;
};

export default PatientRecordLink;
